import type { AdminMember } from '../../hooks/useAdminMembers';

export interface MemberFormValues {
  email: string;
  fullName: string;
  matricule: string;
  hireDate: string;
  teamId: string;
  committee: string;
  managerEmail: string;
  /** Echelon d'entreprise — '' = vide ; 'gestionnaire' = saisi. Edit only. */
  orgLevel: string;
}

export function initialMemberValues(member: AdminMember): MemberFormValues {
  return {
    email: member.email,
    fullName: member.fullName ?? '',
    matricule: member.matricule ?? '',
    hireDate: '',
    teamId: member.teamId ?? '',
    committee: member.committee ?? '',
    managerEmail: member.managerEmail ?? '',
    orgLevel: member.orgLevel ?? '',
  };
}
